// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReportUI_filters__N4QbD{
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px ;
}`, "",{"version":3,"sources":["webpack://./src/pages/logs/styles/ReportUI.module.css"],"names":[],"mappings":"AAAA;EACI,aAAa;EACb,yBAAyB;EACzB,oBAAoB;AACxB","sourcesContent":[".filters{\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 20px ;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filters": `ReportUI_filters__N4QbD`
};
export default ___CSS_LOADER_EXPORT___;
